/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Event_AbsentInputs */



/**
* | output |
* | --- |
* | "Gone from vekn.net" |
*
* @param {Vekn_Event_AbsentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_event_absent = /** @type {((inputs?: Vekn_Event_AbsentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Event_AbsentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Absent de vekn.net")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ausente de vekn.net")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ausente de vekn.net")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assente da vekn.net")
	return /** @type {LocalizedString} */ ("Gone from vekn.net")
});